"use client";
import { Button } from "@base-ui/react/button";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { useCallback } from "react";
import { cn } from "@/lib/utils";

const LETTERS = "abcçdefghijklmnoöprsştuüvyz";
const Letters = () => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const activeLetter = searchParams.get("initial");

  const createQueryString = useCallback(
    (name: string, value: string | undefined) => {
      const params = new URLSearchParams(searchParams.toString());
      if (value) {
        params.set(name, value);
      } else {
        params.delete(name);
      }

      return params.toString();
    },
    [searchParams],
  );
  return (
    <div className="flex flex-row border mt-2 border-gray-300 divide-gray-300 divide-x">
      {LETTERS.split("").map((letter) => {
        return (
          <Button
            className={cn(
              "w-full hover:bg-brand-blue-100 cursor-pointer py-1 text-center uppercase text-xs font-semibold leading-4.5",
              {
                "bg-brand-blue-600 text-white hover:bg-brand-blue-600":
                  letter === activeLetter,
              },
            )}
            key={letter}
            onClick={() => {
              router.push(
                `${pathname}?${createQueryString("initial", letter === activeLetter ? undefined : letter)}`,
              );
            }}
          >
            {letter}
          </Button>
        );
      })}
    </div>
  );
};

export default Letters;
